<template>
  <div v-if="show" class="recharge-notification" ref="notification">
    <div class="sparkles"></div>
    <div class="coin" ref="coinRef">💰</div>
    <div class="content">
      <div class="amount">+{{ amount }}金币</div>
      <div class="text">{{notice}}</div>
    </div>
  </div>
</template>

<script>
import snabbt from '../../../../../node_modules/snabbt.js/snabbt'
import i18nMixin from "@/libs/i18nMixin";

export default {
  name: 'RechargeNotification',
  mixins: [i18nMixin],
  props: {
    duration: {
      type: Number,
      default: 5500
    }
  },
  data() {
    return {
      show: false,
      amount:0,
      notice:''
    }
  },
  mounted() {
    this.$Bus.$on("rechargeSuccess", msg => {
      const jsonData = JSON.parse(msg.data);
      const notice = msg.nickname + this.$i18n('rechargeForLive', '为本场充值') + jsonData.givePrice + this.$i18n('goldCoin', '金币') + this.$i18n('poolRemaining', '！币池剩余：') + jsonData.gameYue;
      this.amount = jsonData.givePrice;
      this.notice = notice;
      this.play();
    });
  },
  beforeDestroy() {
    this.$Bus.$off("rechargeSuccess");
  },
  methods: {
    play() {
      this.show = true
      this.$nextTick(() => {
        this.play1()
      })
    },
    play1(){
      const el = this.$refs.notification;
      const coin = this.$refs.coinRef;
      // 金币单独动画
      snabbt(coin, {
        scale: [3, 3],
        opacity: 0,
        delay: 200
      }).snabbt({
        scale: [1, 1],
        opacity: 1,
        easing: 'spring',
        springConstant: 1.4,
        springDeceleration: 0.7,
        duration: 400
      }).snabbt({
        rotation: [0, 0, 360],
        duration: 800,
        easing: 'linear'
      })
      // 初始位置设置
      snabbt(el, {
        position: [-300, 0, 0],
        opacity: 0
      }).snabbt({
        position: [20, 0, 0],
        opacity: 1,
        easing: 'easeOut',
        duration: 400
      }).snabbt({
        position: [-10, 0, 0],
        duration: 200
      }).snabbt({
        position: [-100, 0, 0],
        duration: 150
      }).snabbt({
        delay: this.duration,
        opacity: 0,
        duration: 500,
        complete: () => {
          this.show = false
        }
      })
    },
    playAnimation() {
      const el = this.$refs.notification;
      const coin = this.$refs.coinRef;
      // const coin = this.$refs.notification.$el.querySelector('coin');
      // 主容器动画
      snabbt(el, {
        fromPosition: [-200, -100, 0],
        position: [0, 0, 0],
        scale: [0.5, 0.5],
        rotation: [0, 0, -15],
        opacity: 0,
        easing: 'spring',
        springConstant: 0.3,
        springDeceleration: 0.8
      }).snabbt({
        scale: [1, 1],
        rotation: [0, 0, 0],
        opacity: 1,
        duration: 600
      })

      // 金币单独动画
      snabbt(coin, {
        scale: [3, 3],
        opacity: 0,
        delay: 200
      }).snabbt({
        scale: [1, 1],
        opacity: 1,
        easing: 'spring',
        springConstant: 1.4,
        springDeceleration: 0.7,
        duration: 400
      }).snabbt({
        rotation: [0, 0, 360],
        duration: 800,
        easing: 'linear'
      })

      // 自动消失
      snabbt(el, {
        delay: this.duration,
        opacity: 0,
        scale: [0.8, 0.8],
        duration: 500,
        complete: () => {
          this.show = false
        }
      })
    }
  }
}
</script>

<style scoped>
.recharge-notification {
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  background: linear-gradient(45deg, #FFD700, #FFB300);
  padding: 8px 12px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(255, 179, 0, 0.3);
  z-index: 9999;
}

.sparkles {
  position: absolute;
  width: 100%;
  height: 100%;
  /*background: radial-gradient(circle, rgba(255,255,255,0.6) 10%, transparent 20%);*/
  /*animation: twinkle 1.2s infinite;*/
}

@keyframes twinkle {
  0% { opacity: 0.4; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.2); }
  100% { opacity: 0.4; transform: scale(0.8); }
}

.coin {
  font-size: 16px;
  margin-right: 7px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
}

.content {
  line-height: 1.4;
}

.amount {
  font-weight: 800;
  color: #FFF;
  font-size: 12px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
}

.text {
  color: #FFF;
  font-size: 10px;
  opacity: 0.9;
}
</style>